
import { Link } from "react-router-dom";
import { Plus, ArrowUpRight, User, Heart, LogOut, UserPlus } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useTranslation } from "react-i18next";

import { SubscriptionStatusLite } from "@/types/domain";

interface MobileMenuAuthContentProps {
  isAdmin: boolean;
  subscriptionStatus: SubscriptionStatusLite | null;
  shouldShowUpgradeButton: boolean;
  hasPendingVerification: boolean;
  referralLink: string;
  onLinkClick: () => void;
  onSignOut: () => void;
}


const MobileMenuAuthContent = ({
  isAdmin, subscriptionStatus, shouldShowUpgradeButton, hasPendingVerification,
  referralLink, onLinkClick, onSignOut
}: MobileMenuAuthContentProps) => {
  const { t } = useTranslation(['common', 'dashboard']);
  
  return (
    <>
      <div className="flex flex-col gap-2">
        {shouldShowUpgradeButton ? (
          <Link
            to={hasPendingVerification ? "#" : "/profile?tab=subscription"}
            onClick={onLinkClick}
            className={`flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors ${hasPendingVerification ? 'pointer-events-none text-brand-slate opacity-50' : 'text-brand-ink hover:bg-brand-mist'}`}
          >
            {hasPendingVerification ? t("userMenu.paymentPending") : (<><ArrowUpRight className="h-4 w-4" />{t("userMenu.upgradeToPremium")}</>)}
          </Link>
        ) : (
          <Link to="/submit-listing" onClick={onLinkClick} className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-brand-ink transition-colors hover:bg-brand-mist">
            <Plus className="h-4 w-4" /> {t("userMenu.addListing")}
          </Link>
        )}
        
        <Link to="/user/listings" onClick={onLinkClick} className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-brand-ink transition-colors hover:bg-brand-mist">
          <User className="h-4 w-4" /> {t("userMenu.myListings")}
        </Link>

        <Link to="/favorites" onClick={onLinkClick} className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-brand-ink transition-colors hover:bg-brand-mist">
          <Heart className="h-4 w-4" /> {t("dashboard:userMenu.myFavorites")}
        </Link>
        
        <a href={referralLink} target="_blank" rel="noopener noreferrer" onClick={onLinkClick} className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-brand-ink transition-colors hover:bg-brand-mist">
          <UserPlus className="h-4 w-4" /> {t("userMenu.referFriend")}
        </a>
        
        <Link to="/profile" onClick={onLinkClick} className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-brand-ink transition-colors hover:bg-brand-mist">
          <User className="h-4 w-4" /> {t("userMenu.profile")}
        </Link>
        
        {!isAdmin && !hasPendingVerification && (subscriptionStatus?.tier === 'free_tier' || subscriptionStatus?.tier === 'whatsapp_tier') && (
          <Link to="/profile?tab=subscription" onClick={onLinkClick} className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-brand-ink transition-colors hover:bg-brand-mist">
            <ArrowUpRight className="h-4 w-4" /> {t("userMenu.upgradeToPremium")}
          </Link>
        )}
        
        {isAdmin && (
          <Link to="/admin" onClick={onLinkClick} className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-brand-ink transition-colors hover:bg-brand-mist">
            {t("navigation.admin")}
          </Link>
        )}
      </div>
      
      <Separator className="my-2" />
      
      <button onClick={onSignOut} className="flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-coral transition-colors hover:bg-red-50">
        <LogOut className="h-4 w-4" /> {t("userMenu.logout")}
      </button>
    </>
  );
};

export default MobileMenuAuthContent;
